import PropTypes from 'prop-types';

const UnreadMessages = ({unreadMessages, show, url}) => (show && unreadMessages > 0) && (
  <div>
    <a className="btn btn-grey my-messages-button" href={url}>
      <i className="fa fa-envelope" aria-hidden="true"/>
      <div className="message-count">
        {unreadMessages}
      </div>
    </a>
  </div>
);

UnreadMessages.propTypes = {
  unreadMessages: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
};

export default UnreadMessages;
